import React, { useContext } from "react";
import { ConfigContext } from "../../../../contexts/ConfigContext";
import { THEME_NAMES } from "../../../../config/themes/config";
import { ApplicationInfo } from "./ApplicationInfo";
import { ApplicationInfoVideoId } from "../ApplicationInfoVideoId/ApplicationInfoVideoId";

export const ApplicationInfoFactory = (props) => {
  const {
    state: { themeName },
  } = useContext(ConfigContext);

  if (themeName === THEME_NAMES.ktuin) {
    return <ApplicationInfoVideoId {...props} />;
  }

  return <ApplicationInfo {...props} />;
};
